import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import React, { useEffect, useRef, useState } from "react";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import "../../../assets/topstudio/styles/Player.css";
import Volume from "./Volume";
import axiosInstance from "../../../utils/axiosInstance";

export default function SideBetCity() {

    const [showRules, setShowRules] = useState(false);
    const [open, setOpen] = useState(false);
    const [displayLoader, setDisplayLoader] = useState(true);
    const [activeTabIndex, setActiveTabIndex] = useState(1);
    const [roundId, setRoundId] = useState("");
    const [resultData, setResultData] = useState([]);

    /* ================= TIMER ================= */
    const TOTAL_SECONDS = 30;
    const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
    const localTimerRef = useRef(null);

    useEffect(() => {
        setDisplayLoader(false);

    }, []);


    const R = 45;
    const CIRC = 2 * Math.PI * R;
    const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
    const timerColor =
        timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";


    const activeTab = async (tab1) => {
        setActiveTabIndex(tab1);
        if (tab1 == 2) {
            showResultDetail();
        }
    };

    /// result detail ///
    const showResultDetail = async () => {
      let resultObj = {};
      resultObj.game_type = "tp20_virtual";

      const response = await axiosInstance.post(
        "/teenpatti-results",
        resultObj
      );

      setResultData(response.data.results_list);
      //console.log("response->", resultData);
    };
    return (
        <>
            <div className="aviator-scope player-scope aviator-bg-black">
                <ClientLayoutWithOutHeader showLoader={false}>
                    <div class="details-tabs-wrapper1">
                        <div className="main-page">
                            <div className="row no-gutters">
                                <div className="col-md-12">
                                    <div className="bodyheight">
                                        <div className="wrapper">
                                            <TPStudioSidebar open={open} />
                                        </div>
                                        <div className="lobby-ctn BPGmaindiv">
                                            <TpStudioHeader setOpen={setOpen} open={open} />
                                            <TpStudioLoader displayLoader={displayLoader} />
                                        </div>




                                        <div
                                            className="row"
                                            style={{ display: displayLoader ? "none" : "" }}
                                        >
                                            <div className="col-md-8">
                                                <div className="left-content">
                                                    <div>
                                                        {" "}
                                                        <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                                                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                                                <p>Side Bet City</p>
                                                            </div>
                                                            <div
                                                                className="col-6 col-md-6 inline-block Gameidcol text-right"
                                                                style={{ marginTop: "4px" }}
                                                            >
                                                                <div
                                                                    role="group"
                                                                    aria-label="Second group"
                                                                    className="btn-group btn-group-sm mr-2"
                                                                >
                                                                    <button
                                                                        style={{ fontSize: "14px" }}
                                                                        type="button"
                                                                        id="Alltab"
                                                                        className={
                                                                            activeTabIndex == 1
                                                                                ? "tablink btn btn-primary bbactive"
                                                                                : "tablink btn btn-primary"
                                                                        }
                                                                        onClick={() => activeTab(1)}
                                                                    >
                                                                        Game
                                                                    </button>
                                                                    <button
                                                                        style={{ fontSize: "14px" }}
                                                                        type="button"
                                                                        id="RESULTStab"
                                                                        className={
                                                                            activeTabIndex == 2
                                                                                ? "tablink btn btn-primary bbactive"
                                                                                : "tablink btn btn-primary"
                                                                        }
                                                                        onClick={() => activeTab(2)}
                                                                    >
                                                                        Results
                                                                    </button>
                                                                    <button
                                                                        style={{ fontSize: "14px" }}
                                                                        type="button"
                                                                        className="tablink btn btn-primary"
                                                                        onClick={() => setShowRules(true)}
                                                                    >
                                                                        Rules
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Footer */}
                                                    <center
                                                        style={{
                                                            display: activeTabIndex == 1 ? "" : "none"
                                                        }}
                                                    >
                                                        <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                                            <div className="buttons-div">
                                                                {[
                                                                    "4X",
                                                                    "1X",
                                                                    "0X",
                                                                    "0X",
                                                                    "5X",
                                                                    "5X",
                                                                    "9X",
                                                                    "3X",
                                                                    "1X",
                                                                    "4X"
                                                                ].map((btn, idx) => (
                                                                    <button
                                                                        key={idx}
                                                                        className="video-button border-gradient-btn border-gradient-purple-btn"
                                                                    >
                                                                        {btn}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                            <div className="round-div">
                                                                <div className="label">Round ID:</div>
                                                                <div className="id">{roundId}</div>
                                                            </div>
                                                        </div>
                                                    </center>
                                                </div>
                                            </div>

                                            <div className="col-md-4 mobile-margin">
                                                <div>
                                                    <div className="bets">
                                                        <strong>
                                                            Matched Bets (0)
                                                            <img
                                                                src={reconnecting}
                                                                alt="dc"
                                                                className="rounded disconnected"
                                                                style={{ display: "none" }}
                                                            />{" "}
                                                        </strong>
                                                        <div className="betting-table">
                                                            <table className="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Runner</th>
                                                                        <th>Price</th>
                                                                        <th>Size</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ClientLayoutWithOutHeader>
            </div>
        </>
    );
}